/*
 *  Copyright 2025 LiteFarm.org
 *  This file is part of LiteFarm.
 *
 *  LiteFarm is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  LiteFarm is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 *  GNU General Public License for more details, see <https://www.gnu.org/licenses/>.
 */

import { api } from './apiSlice';
import { supportTicketUrl } from '../../apiConfig';
import { SupportTicketData } from './types';

export const supportTicketApi = api.injectEndpoints({
  endpoints: (build) => ({
    addSupportTicket: build.mutation<SupportTicketData, SupportTicketData>({
      query: ({ file, data }) => {
        const formData = new FormData();
        formData.append('_file_', file);
        formData.append('data', JSON.stringify(data));

        return {
          url: `${supportTicketUrl}`,
          method: 'POST',
          body: formData,
        };
      },
    }),
  }),
});

export const { useAddSupportTicketMutation } = supportTicketApi;
